module.exports = __webpack_public_path__ + "static/media/mk.08945e69.svg";